import { useMemo } from 'react'

import type { LabeledOption } from '@fv/client-components/combobox'
import type { GLCode } from '@fv/models'

import { ShipperTypeahead } from '@/components/inputs/ShipperTypeahead'
import { useUserSettings } from '@/hooks/settings'

type Option = LabeledOption & { description?: string }

type Props = {
  value?: string | null
  onChange: (value: string | null) => void
  disabled?: boolean
  required?: boolean
}

export const GLCodeSelector = ({
  value,
  onChange,
  disabled,
  required,
}: Props) => {
  const settingsQuery = useUserSettings()
  const glCodes = settingsQuery?.data?.glCodes || []

  const options: Option[] = useMemo(
    () =>
      glCodes.map((code: GLCode) => ({
        label: code.code + (code.description ? ` - ${code.description}` : ''),
        value: code.code,
        description: code.description,
      })),
    [glCodes],
  )

  const selectedOption = options.find(o => o.value === value) ?? null

  return (
    <ShipperTypeahead
      classNames={{
        container: 'w-full',
      }}
      options={options}
      value={selectedOption}
      onSelect={option => onChange(option?.value ?? null)}
      getOptionLabel={o => o.label}
      getOptionValue={o => o.value}
      disabled={disabled}
      isClearable
      showTrigger
      placeholder="Select GL Code..."
      required={required}
    />
  )
}
